/**
* Locked Account
*
* Contains the init function and all dialog renderings and ajax calls
* for locking past due accounts with a modal view
*
* WARNING: This JS may not be served by the same service as the one which serves
* HTML/CSS which this JS depends on. E.g. this JS may be served by a BabyStorm
* while the HTML/CSS may be served by Storm. Take care when updating this JS or any
* related HTML/CSS.
* See https://wiki.yext.to/index.php/Postmortem:IN-1085_Capacity_Limit_Exceeded_Modal_in_Customer_Portal#Root_causes
* for context.
*
* @author Gilbert Fu (gfu@yext.com)
*
*/
goog.module('yext.subscriptions.LockedAccount');
goog.module.declareLegacyNamespace();

const routes = goog.require('yext.subscriptions.routes');
const yext = goog.require('yext');
const dialog = goog.require('yext.dialog');
/** @suppress {extraRequire} */
goog.require('yext.plugins.selectbox');

/**
 * @constructor
 * @param {!jQuery} $dialogContainer
 */
const LockedAccount = function($dialogContainer) {
  if (this.hasDismissWarningLockDialogCookie()) {
    return;
  }
  this.init($dialogContainer);
};

LockedAccount.prototype.init = function($dialogContainer) {
  this.$dialog = $dialogContainer.dialog({
    modal: true,
    dialogClass: 'locked-account-dialog',
    closeOnEscape: false,
    draggable: false,
    resizable: false,
    width: 575,
    height: 'auto',
  });

  this.$firstLockPage = this.$dialog.find('.js-first-lock-page');
  this.$editCardLockPage = this.$dialog.find('.js-edit-card-lock-page');
  this.$confirmationUnlockPage = this.$dialog.find('.js-confirmation-unlock-page');

  if (this.$firstLockPage.length > 0) {
    this.loadDialogContent();
  }
  this.bindEventListeners();
};

LockedAccount.prototype.loadDialogContent = function() {
  var self = this;
  var progressDialog = dialog.showDelayedProgressDialog(yext.msg('Loading...'));

  $.ajax({
    url: routes.LockedPastedDueAccount.renderDialog(),
    type: 'GET',
    success: function(data) {
      dialog.hideDelayedProgressDialog(progressDialog);
      if (!data.hideLockedAccountDialog) {
        self.$firstLockPage.html(data).show();
      }
    },
    error: function() {
      dialog.hideDelayedProgressDialog(progressDialog);
      self.showGenericError();
    },
  });
};

LockedAccount.prototype.loadEditCreditCardContent = function() {
  var progressDialog = dialog.showDelayedProgressDialog(yext.msg('Loading...'));
  var creditCardId = this.$firstLockPage.find('input[name="billingMethodId"]:checked').val();
  var self = this;
  $.ajax({
    url: routes.LockedPastedDueAccount.renderEditCardDialog({
      'creditCardId': creditCardId,
    }),
    type: 'GET',
    success: function(data) {
      dialog.hideDelayedProgressDialog(progressDialog);
      if (data.errorMessages) {
        var $errorContainer = self.$firstLockPage.find('.js-locked-account-error');
        $errorContainer.empty().show();

        $.each(data.errorMessages, function() {
          $errorContainer
            .append('<p class="error-msg">' + this + '</p>');
        });
      } else {
        self.$firstLockPage.hide();
        self.$editCardLockPage.html(data).show();
        self.$editCardLockPage.find('select').selectbox();
        if (creditCardId === 'addCreditCard') {
          var prepopulateFields = {};
          var zuoraCallback = function(response) {
            console.log(response);
            if (response.refId) {
              var setDefaultPaymentMethod =
                self.$editCardLockPage.find('input[name="setDefaultPaymentMethod"]:checked').length > 0;
              var paymentMethodId = response.refId;
              self.chargePaymentMethod(paymentMethodId, setDefaultPaymentMethod);
            }
          };
          var zppParams = JSON.parse(document.getElementById('zuoraHpmParams').value);
          window.Z.render(zppParams, prepopulateFields, zuoraCallback);
        }
      }
    },
    error: function() {
      dialog.hideDelayedProgressDialog(progressDialog);
      self.showGenericError();
    },
  });
};

LockedAccount.prototype.chargePaymentMethod = function(paymentMethodId, setDefaultPaymentMethod) {
  var self = this;
  var progressDialog = dialog.showDelayedProgressDialog(yext.msg('Processing...'));
  $.ajax({
    url: routes.LockedPastedDueAccount.chargePaymentMethod(),
    type: 'POST',
    data: {
      'paymentMethodId': paymentMethodId,
      'setDefaultPaymentMethod': setDefaultPaymentMethod,
    },
    success: function(data) {
      dialog.hideDelayedProgressDialog(progressDialog);
      if (data.errorMessages) {
        var $errorContainer = self.$editCardLockPage.find('.js-locked-account-error');
        $errorContainer.empty().show();

        $.each(data.errorMessages, function() {
          $errorContainer
            .append('<p class="error-msg">' + this + '</p>');
        });
      } else {
        self.$firstLockPage.hide();
        self.$editCardLockPage.hide();
        self.$confirmationUnlockPage.html(data).show();
      }
    },
    error: function() {
      dialog.hideDelayedProgressDialog(progressDialog);
      self.showGenericError();
    },
  });
};

LockedAccount.prototype.confirmCreditCard = function() {
  var paymentMethodId = this.$editCardLockPage.find('input[name="paymentMethodId"]').val();
  var setDefaultPaymentMethod = this.$editCardLockPage.find('input[name="setDefaultPaymentMethod"]:checked').length > 0;
  this.chargePaymentMethod(paymentMethodId, setDefaultPaymentMethod);
};

/**
 * Returns a map containing all of the inputs entered by the user
 *
 * @return {!Object<string, string>} An map containing all possible fields in the new credit card form
 *                                  and their current values as entered by the user
 */
LockedAccount.prototype.getNewCreditCardFormInput = function() {
  var data = {};
  var fields = [
    'address',
    'address2',
    'city',
    'state',
    'postalCode',
    'country',
    'creditCardNumber',
    'expirationMonth',
    'expirationYear',
    'CVV',
    'cardHolderName',
  ];
  var $creditCardForm = this.$editCardLockPage.find('[name="creditCardForm"]');
  $.each(fields, function(index, field) {
    data[field] = $creditCardForm.find('[name="newCreditCardInfo.' + field + '"]').val() || undefined;
  });

  var isDefaultPaymentMethod = this.$editCardLockPage.find('input[name="newCreditCardInfo.isDefaultPaymentMethod"]:checked').length > 0;
  data['isDefaultPaymentMethod'] = isDefaultPaymentMethod;

  return data;
};

LockedAccount.prototype.showGenericError = function() {
  var $errorContainer = this.$dialog.find('.js-locked-account-error');
  $errorContainer.empty().show();
  $errorContainer
    .append(
      '<p class="error-msg">' +
        yext.msg('We are unable to process your request at the moment. If the problem persists, please contact Yext Support.') +
      '</p>');
};

LockedAccount.prototype.bindEventListeners = function() {
  var self = this;

  this.$dialog.on('click', '.js-edit-credit-card-button', function() {
    self.loadEditCreditCardContent();
  });

  this.$dialog.on('click', '.js-submit-credit-card-button', function() {
    self.confirmCreditCard();
  });

  this.$dialog.on('click', '.js-close-dialog-link', function() {
    self.$dialog.dialog('close');
    self.setDismissWarningLockDialogCookie();
    location.reload();
  });

  this.$dialog.on('click', '.js-back-dialog-link', function() {
    self.$dialog.find('.js-locked-account-error').empty().hide();
    self.$firstLockPage.show();
    self.$editCardLockPage.hide();
  });
};

LockedAccount.prototype.setDismissWarningLockDialogCookie = function() {
  // expires in 1 day, make path visible for resellers and storm domain
  $.cookie('dismissWarningLockDialog', yext.businessId, {expires: 1, path: '/'});
};

LockedAccount.prototype.hasDismissWarningLockDialogCookie = function() {
  if ($.cookie('dismissWarningLockDialog') == yext.businessId) {
    return true;
  } else {
    if ($.cookie('dismissWarningLockDialog')) {
      // delete cookie
      $.cookie('dismissWarningLockDialog', null, {path: '/'});
    }
    return false;
  }
};
goog.exportSymbol('yext.subscriptions.LockedAccount', LockedAccount);

exports = LockedAccount;
